
import config from '../api/constants'
import http from '../api/api'

const getRegistrationRequiredValues = async () => {
  try {
    const reqParams = {
      requestId:"CREATECUSTOMER"
    }
    const response = await http.post(config.apiRoute.NEWCUSTOMER_GET_REQUIRED_VALUES, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const getCountryCodes = async () => {
  try {
    const reqParams = {
      requestId: 'GETCOUNTRYCODES',
    }
    const response = await http.post(config.apiRoute.NEWCUSTOMER_GET_COUNTRY_CODES, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const getBranchCodes = async () => {
  try {
    const reqParams = {
      requestId: 'GETBRANCHDETAILS',
    }
    const response = await http.post(config.apiRoute.NEWCUSTOMER_GET_BRANCH_CODES, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const generateNewCustomerOTP = async (data) => {
  try {
    const reqParams = {
      emailId: data?.email,
      mobileNumber: data?.mobile,
      requestId: 'GENERATEOTP',
      userName: data?.username,
    }
    const response = await http.post(config.apiRoute.NEWCUSTOMER_GENERATE_OTP, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const getEmpDetails = async () => {
  try {
    const reqParams = {
      channelType: "RETAILWEB",
      requestId: "EMPDETFORCUSTONBOARD",
      userName: "DEFAULT",
    }
    const response = await http.post(config.apiRoute.NEWCUSTOMER_GET_EMP_DETAILS, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const getNewCustomerTerms = async () => {
  try {
    const reqParams = {
      module: 'REGISTRATION',
      requestId: 'TERMS',
      type:"RETAIL",
    }
    const response = await http.post(config.apiRoute.NEWCUSTOMER_GET_TERMS, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const createNewCustomer = async ({
  accountType,
  city,
  commune,
  countryOfIssuance,
  // currencyType,
  // province,
  customerIdentityType,
  district,
  dob,
  email,
  employmentType,
  expiredDate,
  familyName,
  givenName,
  group,
  houseNumber,
  identityNumber,
  incomeRange,
  issueDate,
  maritalStatus,
  middleName,
  mobile,
  mobileCountryCode,
  // gender,
  occupatio,
  eduStatus,
  nationality,
  birthCountry,
  placeOfBirth,
  randomKey,
  selfieImageData,
  sourceOfIncome,
  street,
  // taxId,
  title,
  usCitizenFLag,
  village,
  frontImageData,
  backImageData,
  proofOfResidency,
  // tpinCertificate,
  // signature,
  curEmp,
  empCountry,
  // pinCode,
  // noOfDependents,
  // expectedTurnOver,
  // districtType,
  empDesc,
  otp,
  // purposeOfAccOpening,
  // branchCode,
  // branchName,
  // isDebitCard,
  ageGroup,
  signatureImageData,
  proofOfResidenceImageData,
  howKnowAboutBank
}) => {
  try {
    const reqParams = {
      randomKey,
      // accountCurrency: currencyType,
      // province,
      accountType,
      title,
      familyName,
      givenName,
      middleName,
      dateOfBirth: dob,
      birthCountry,
      placeOfBirth,
      nationality,
      occupatio,
      customerIdentityType,
      identityNumber,
      issueDate,
      expiredDate,
      countryOfIssuance,
      // taxId,
      maritalStatus,
      mobileNoCountryCode: mobileCountryCode,
      mobileNumber: mobile,
      emailId: email,
      houseNumber,
      street,
      city,
      district,
      commune,
      village,
      group,
      employmentType,
      sourceOfIncome,
      incomeRange,
      usCitizenFLag,
      selfieImageData,
      idProofFrontImageData: frontImageData,
      idProofBackImageDate: backImageData,
      proofOfResidency,
      // tpinCertificate,
      // signature,
      requestId: 'CREATECUSTOMER',
      userName: 'DEFAULT',
      customerId:"DEFAULT",
      otp: otp,
      password: '',
      accAdditionalService: '',
      branchCode: '',
      branchName: '',
      howKnowAboutBank: howKnowAboutBank,
      purposeOfAccOpening: '',
      secondNationality: '',
      curEmp: curEmp,
      // custMode: "M",
      // customerCategory: "150",
      // districtType: districtType,
      eduStatus,
      empCountry,
      empDesc: empDesc,
      // empStatus: "F",
      // gender,
      // shortName: "",
      // tpin: taxId,
      // pinCode,
      // noOfDependents,
      // expectedTurnOver,
      module:"Information",
      // debitCard: isDebitCard,
      ageGroup,
      signatureImageData,
      proofOfResidenceImageData,
    }
    const response = await http.post(config.apiRoute.NEWCUSTOMER_CREATE_CUSTOMER, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}


const getUdfDetails = async () => {
  try {
    const response = await http.post(config.apiRoute.UDF_DETAILS, {})
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

export const validateID = async (data) => {
  try {
    const reqParams = {
      accountType: data.accountType,
      identityNumber: data.identityNumber,
      requestId: 'VALIDATEID',
    }
    const response = await http.post(config.apiRoute.VALIDATEID, reqParams)
    return { status: response.status, data: response.data };
  } catch (err) {
    throw err.response.data
  }
}

export const getMISCode = async () => {
  try {
    const reqParams = {
      accMisClass: "",
      requestId: "GETMISCODE",
    }
    const response = await http.post(config.apiRoute.REGISTRATION_MIS_CODE, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const NewCustomerService = {
  getRegistrationRequiredValues,
  getCountryCodes,
  getBranchCodes,
  generateNewCustomerOTP,
  getEmpDetails,
  getNewCustomerTerms,
  createNewCustomer,
  getUdfDetails,
  validateID,
  getMISCode
}

export default NewCustomerService